var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "statistics-place-filter" },
    [
      _c("BBDropdown", {
        attrs: { positionClass: "right" },
        scopedSlots: _vm._u([
          {
            key: "toggle",
            fn: function () {
              return [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.selectedPlace
                        ? _vm.selectedPlace.name
                        : _vm.$t(
                            "statisticsFilters.placeFilter.allLocationsLabel"
                          )
                    )
                  ),
                ]),
                _c("i", { staticClass: "la la-angle-down" }),
              ]
            },
            proxy: true,
          },
          {
            key: "items",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass: "action-item",
                    on: {
                      click: function ($event) {
                        return _vm.selectPlace()
                      },
                    },
                  },
                  [
                    _c("i", {
                      class: !_vm.selectedPlace ? "fas fa-check" : "",
                    }),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "statisticsFilters.placeFilter.allLocationsLabel"
                          )
                        )
                      ),
                    ]),
                  ]
                ),
                _vm._l(_vm.allPlaces, function (place) {
                  return _c(
                    "div",
                    {
                      key: place.id,
                      staticClass: "action-item",
                      on: {
                        click: function ($event) {
                          return _vm.selectPlace(place)
                        },
                      },
                    },
                    [
                      _c("i", {
                        class:
                          _vm.selectedPlace && _vm.selectedPlace.id === place.id
                            ? "fas fa-check"
                            : "",
                      }),
                      _c("span", [_vm._v(_vm._s(place.name))]),
                    ]
                  )
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }